import dynamic from 'next/dynamic';
import styles from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function OceanProHomeSolarBattery() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`ocean-pro-home-solar-battery ${styles['ocean-pro-home-solar-battery']}`}>
            <IndexDynamic />
        </div>
    );
}
